module.exports = __webpack_public_path__ + "img/Stage_4_Atmo.edd3ee82.jpg";